export class Occupation {
  public id?: string;
  public name: string;
}
